import { render } from "./RegulationNews.vue?vue&type=template&id=2a1c3662"
import script from "./RegulationNews.vue?vue&type=script&lang=js"
export * from "./RegulationNews.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__